export default __webpack_public_path__ + "static/media/cz.d1401815.svg";